import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query'

import { listAllCompaniesRequest } from '../../../apis/calyxSaaSDashboardAPI'
import type { InternalCompany } from '../types/internalCompany'

export const COMPANIES_QUERY_KEY = ['list', 'companies'] as const

const FIVE_MINUTES_MS = 5 * 60 * 1000

type SelectOption<TSelected> = Pick<
  UseQueryOptions<InternalCompany[], unknown, TSelected>,
  'select'
>

export function useCompaniesQuery(): UseQueryResult<InternalCompany[]>
export function useCompaniesQuery<TSelected>(
  options: SelectOption<TSelected>,
): UseQueryResult<TSelected>
export function useCompaniesQuery<TSelected>(
  options?: SelectOption<TSelected>,
): UseQueryResult<TSelected | InternalCompany[]> {
  return useQuery<InternalCompany[], unknown, TSelected | InternalCompany[]>(
    COMPANIES_QUERY_KEY,
    () => listAllCompaniesRequest() as Promise<InternalCompany[]>,
    {
      staleTime: FIVE_MINUTES_MS,
      select: options?.select,
    },
  )
}
